/**
 * Display label for a form template row from /api/v2/forms/ in selects.
 * Avoids "(undefined)" when optional fields are missing — e.g. legacy
 * `name + ' (' + type + ')'` coerces undefined to the string "undefined".
 */
export function getFormTemplateSelectLabel(row) {
    if (!row || typeof row !== "object") {
        return "";
    }
    const raw =
        row.name != null && String(row.name).trim() !== ""
            ? String(row.name).trim()
            : "";
    const base = raw.replace(/\s*\(undefined\)\s*$/i, "").trim();

    const cat =
        row.equipment_category_name != null &&
        String(row.equipment_category_name).trim() !== "" &&
        String(row.equipment_category_name).trim().toLowerCase() !== "undefined"
            ? String(row.equipment_category_name).trim()
            : "";

    const typePart =
        row.type != null &&
        String(row.type).trim() !== "" &&
        String(row.type).trim().toLowerCase() !== "undefined"
            ? String(row.type).trim()
            : "";

    const suffix = cat || typePart;
    if (!suffix) {
        return base;
    }
    if (base.includes(`(${suffix})`)) {
        return base;
    }
    return `${base} (${suffix})`;
}
